import ApiClientRequest from "../ApiClientRequest";
import BaseApiClientException from "./BaseApiClientException";
import { ApiClientResponse } from "..";

class ConflictException extends BaseApiClientException {
    static STATUS_CODE = 409;
    constructor(
        request: ApiClientRequest,
        response: ApiClientResponse<unknown>
    ) {
        super("Conflict", ConflictException.STATUS_CODE, request, response);
    }
}

export default ConflictException;
